import { render, staticRenderFns } from "./GroundStationIndexSettings.vue?vue&type=template&id=4b054864&"
import script from "./GroundStationIndexSettings.vue?vue&type=script&lang=ts&"
export * from "./GroundStationIndexSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports